import { makeObservable, observable, action } from 'mobx'
import axios from "axios"
import * as qs from "qs";

class Data {

	item = []
	all = []
	in_progress = []
	in_delivery = []
	new = []
	point = {
		"products_list" : []
	}
	error = false
	loading = true


	constructor() {
		makeObservable( this, {
			getByStatus: action,
			getById: action,
			getPoint: action,
			setProducts: action,
			point: observable,
			item: observable,
			all: observable,
			in_progress: observable,
			in_delivery: observable,
			new: observable,
			loading: observable,
			error: observable
		} )
	}

	getByStatus( status ) {

		this.loading = true

		this.id_point = localStorage.getItem( `id_point` );

		axios.get( `orders_complete${status === `` ? `` : `?status=${status}`}&id_point=${this.id_point}` )
			.then( ( response ) => {
				this[status] = (response.data)
			} )
			.catch( ( error ) => {
				this.error = (error.response.data)
			} )
			.finally( () => {
				this.loading = false
			} )

	}

	getById( id ) {

		this.item = []
		this.loading = true

		axios.get( `orders_complete/get/${id}` )
			.then( ( response ) => {
				this.item = (response.data)
			} )
			.catch( ( error ) => {
				this.error = (error.response.data)
			} )
			.finally( () => {
				this.loading = false
			} )

	}

	getPoint(){

		this.loading = true

		axios.get( `point/index/${localStorage.getItem(`id_point`)}`)
			.then( ( response ) => {
				this.point = response.data;
				this.setProducts();
			} )
			.catch( ( error ) => {
				this.error = (error.response.data)
			} )
			.finally( () => {
				this.loading = false
			} )

	}

	setProducts(){

		this.loading = true;

		this.point.id_products = this.point.id_products !== null ? (this.point.id_products.toString().includes(",") ? this.point.id_products.split(",") : (this.point.id_products ? [this.point.id_products] : [])) : [];
		this.point.products_list = [];

		this.point.id_products && this.point.id_products.forEach( item => {
			if( item ){
				this.point.products_list.push( this.point.products.find( p => p.id == item ) )
			}
		})

		this.point.products = this.point.products.filter( ( el ) => !this.point.products_list.includes( el ) );

		this.loading = false;

	}

	updatePoint( data ) {

		this.loading = true

		axios.post( `point/update/${localStorage.getItem(`id_point`)}`, qs.stringify(data) )
			.then( ( response ) => {
				this.point = response.data;
				this.setProducts();
			} )
			.catch( ( error ) => {
				this.error = (error.response.data)
			} )
			.finally( () => {
				this.loading = false
			} )

	}

	changeStatus( status, id ) {

		this.loading = true

		axios.post( `orders_complete/status/${id}`, qs.stringify({status}) )
			.then( ( response ) => {
				this.getByStatus( `new` );
				this.getByStatus( `in_progress` );
				this.getByStatus( `in_delivery` );
			} )
			.catch( ( error ) => {
				this.error = (error.response.data)
			} )
			.finally( () => {
				this.loading = false
			} )

	}

}

export default new Data()
